import React from 'react';

import {renderEventStatusName} from '@utils/status';

import {buildEventTimeDisplayFragments} from './buildEventTimeDisplayFragments';
import {renderTimePopup} from './renderTimePopup';

export const renderEventTimeBlock = (row, options = {}) => {
    const {
        rangeBetweenStartAndEnd = 'liveControlBreaks',
        keyPrefix = 'ecsd',
        fragmentKeyPrefix = 'rtc',
    } = options;

    const renderTimeComponents = buildEventTimeDisplayFragments(row, {
        rangeBetweenStartAndEnd,
        keyPrefix,
    });

    if (row.match_id || row.stage_id) {
        return renderTimePopup(row, renderTimeComponents);
    }

    return (
        <React.Fragment key={`${fragmentKeyPrefix}_${row.id}`}>
            {renderTimeComponents}
            {renderEventStatusName(row.event_status_id, row.event_status, row.match_status_name, false)}
        </React.Fragment>
    );
};

export const renderTime = (row) =>
    renderEventTimeBlock(row, {
        rangeBetweenStartAndEnd: 'liveControlBreaks',
        keyPrefix: 'ecsd',
        fragmentKeyPrefix: 'rtc',
    });
